/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import http from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
import { FEATURE_INTEREST } from '../constants/EarlyRequesterNames';
import getEarlyRequesterResult from './getEarlyRequesterResult';

/**
 * The feature schema for the growthFeatureWithDefaultDescription field returned from
 * `/v1/calculated-features/translated`
 *
 * @see {@link [UpgradeManagementService](https://tools.hubteam.com/api-catalog/services/UpgradeManagementService/v1/spec/internal#operations-Calculated_Features-get-%2Fupgrade-management-service%2Fv1%2Fcalculated-features%2Ftranslated)}
 */

export const fetchFeatureInterest = productLevelFilter => {
  const fetchFeatureInterestUrl = `${getFullUrl('app-api')}/upgrade-management-service/v1/calculated-features/translated`;
  const earlyRequest = getEarlyRequesterResult(FEATURE_INTEREST);
  const fetchFeatureInterestPromise = () => http.get(fetchFeatureInterestUrl, {
    query: {
      productLevel: productLevelFilter
    }
  });
  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => fetchFeatureInterestPromise()) : null;
  return earlyRequestWithRetry || fetchFeatureInterestPromise();
};